export default {
  CARTITEMS_REMOVE_START: 'CARTITEMS_REMOVE_START',
  CARTITEMS_REMOVE_SUCCESS: 'CARTITEMS_REMOVE_SUCCESS',
  CARTITEMS_REMOVE_FAIL: 'CARTITEMS_REMOVE_FAIL',
  CARTITEMGROUP_REMOVE_START: 'CARTITEMGROUP_REMOVE_START',
  CARTITEMGROUP_REMOVE_SUCCESS: 'CARTITEMGROUP_REMOVE_SUCCESS',
  CARTITEMGROUP_REMOVE_FAIL: 'CARTITEMGROUP_REMOVE_FAIL',
  CARTITEMS_QUANTITY_UPDATE_START: 'CARTITEMS_QUANTITY_UPDATE_START',
  CARTITEMS_QUANTITY_UPDATE_SUCCESS: 'CARTITEMS_QUANTITY_UPDATE_SUCCESS',
  CARTITEMS_QUANTITY_UPDATE_FAIL: 'CARTITEMS_QUANTITY_UPDATE_FAIL',
};
